// extracted by mini-css-extract-plugin
export default {"v-med":"(max-width: 768px)","card":"horizontal__card__j_iz1","imageContainer":"horizontal__imageContainer__mK2jI","content":"horizontal__content__AyBAn"};